import { animate, spring } from "motion";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";

export default class NavOverlay {
  constructor(navbar) {
    this.navbar = navbar;
    // this.toggle = $(this.navbar).find(".page-navbar__overlay-toggle")[0];
    this.toggleTab = $(document.body).find(".overlay-toggle-tab")[0];

    this.searchWrapper = $(".search-wrapper")[0];
    this.mainContent = $(".main-content")[0];
    this.pageFooter = $("#target_footer_bottom")[0];

    if (this.toggleTab) {
      this._init();
    }
  }

  _init() {
    this.$subNavs = $(this.navbar).find(
      ".page-navbar__overlay li.menu-item-has-children.menu-item",
    );
    this.$subNavsLinks = $(this.navbar).find(
      ".page-navbar__overlay li.menu-item-has-children.menu-item > a",
    );
    this.overlay = $(this.navbar).find(".page-navbar__overlay")[0];
    this.menu = $(this.navbar).find(".page-navbar__overlay-menu")[0];

    // this.toggle.addEventListener("click", this._handelToggleClick.bind(this));
    this.toggleTab.addEventListener(
      "click",
      this._handelToggleClick.bind(this),
    );
    this.$subNavsLinks.on("click", this._handelNavItemsClick.bind(this));

    $(window).on(
      "luther:navbar--uses-overlay",
      this._handleDesktopnavToggle.bind(this),
    );
  }

  _handelNavItemsClick(evt) {
    evt.preventDefault(evt);
    const $parentLi = $(evt.currentTarget).closest("li");
    this._toggleSubMenu($parentLi);
  }

  _handelToggleClick() {
    var isOverlayOpen = this.isOverlayOpen || false;
    if (!isOverlayOpen) {
      this._openOverlay();
    } else {
      this._closeOverlay();
    }
  }

  _toggleSubMenu($parentLi) {
    if (!$parentLi.hasClass("is-open")) {
      this._openSubmenu($parentLi);
    } else {
      this._hideSubmenu($parentLi);
    }
    // close all other submenus
    $parentLi
      .closest("ul")
      .find("li.is-open")
      .each((i, el) => {
        if (el === $parentLi[0]) return;
        this._hideSubmenu($(el));
      });
  }

  _openSubmenu($parentLi, extra = 0) {
    const sub = $parentLi.find(".sub-menu").first()[0];
    if (!sub || !sub.scrollHeight) return;
    $parentLi.addClass("is-open");
    const height = `${sub.scrollHeight + extra}px`;
    animate(
      sub,
      { height },
      { duration: 0.1, easing: spring({ stiffness: 300, damping: 100 }) },
    );

    // parent
    const $parentSubmenuLi = $parentLi
      .parent()
      .closest(".menu-item-has-children.is-open");
    if ($parentSubmenuLi.length) {
      // add scrollHeight from child
      this._openSubmenu($parentSubmenuLi, sub.scrollHeight);
    }
  }

  _hideSubmenu($parentLi, extra = 0) {
    const sub = $parentLi.find(".sub-menu").first()[0];
    if (extra === 0) {
      $parentLi.removeClass("is-open");
    }
    const height = extra ? `${sub.clientHeight - extra}px` : 0;
    animate(sub, { height }, { duration: 0.5 });

    // parent
    const $parentSubmenuLi = $parentLi
      .parent()
      .closest(".menu-item-has-children.is-open");
    if ($parentSubmenuLi.length) {
      const newExta = sub.scrollHeight;
      this._hideSubmenu($parentSubmenuLi, newExta);
    }
  }

  _handleDesktopnavToggle(showDesktopNav) {
    if (showDesktopNav && this.isOverlayOpen) {
      this._closeOverlay();
    }
  }

  _openOverlay() {
    this.isOverlayOpen = true;
    this.overlay.removeAttribute("inert");
    this.overlay.setAttribute("aria-hidden", "false");
    // this.toggle.setAttribute("aria-expanded", "true");
    if (this.searchWrapper) {
      this.searchWrapper.setAttribute("inert", "");
    }
    this.mainContent.setAttribute("inert", "");
    this.pageFooter.setAttribute("inert", "");
    document.body.classList.add("navbar--overlay-is-open");
    disableBodyScroll(this.overlay);
  }

  _closeOverlay() {
    this.isOverlayOpen = false;
    this.overlay.setAttribute("inert", "");
    this.overlay.setAttribute("aria-hidden", "true");
    // this.toggle.setAttribute("aria-expanded", "false");
    if (this.searchWrapper) {
      this.searchWrapper.removeAttribute("inert");
    }
    this.mainContent.removeAttribute("inert");
    this.pageFooter.removeAttribute("inert");
    document.body.classList.remove("navbar--overlay-is-open");
    enableBodyScroll(this.overlay);
  }
}
